var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"days"},_vm._l((_vm.daysText),function(dayText,idx){return _c('span',{key:dayText,class:{ 'selected': _vm.isSelected(idx) }},[_vm._v(" "+_vm._s(dayText.charAt(0))+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }